import { render } from "./App.vue?vue&type=template&id=215a5894"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=215a5894&lang=css"

import exportComponent from "C:\\Users\\PM_HMS\\WebstormProjects\\vidos_web_landing-master\\vidos_web_landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__